/**
 *
 */
function RIndexController() {}

RIndexController.prototype = {
  constructor: RIndexController,
  redirectReason: false,

  init: function() {
    PortalMain.authRedirect();
    PortalHelper.debugMessage("React Index Controller Initialized");
  },

  run: function() {
    PortalHelper.debugMessage("React Index Controller Ran");
  },

};
